import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Comment: ITypeSpecificPolicy<types.Comment> = {

  fields: {
    createdAt: dateTimeFieldPolicy()
  }

};
